<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- 菜单 -->
        <div class="products-section" v-for="(item, index) in menuItems" :key="item.id || index">
          <div class="section-header" @click="item.children && item.children.length ? toggleSection(index) : null">
            <h3>{{ item.title }}</h3>
            <span class="dropdown-icon el-icon-arrow-down" v-if="item.children && item.children.length"></span>
          </div>
          <ul class="products-list" v-show="expandedSections[index]">
            <li v-for="child in item.children" :key="child.id" @click="handleMenuClick(item,child)">
              {{ child.title }}
            </li>
          </ul>
        </div>

        <!-- 最后的菜单，直接跳转 -->
        <div class="products-section" v-for="item in lastListRouter" :key="item.name" @click="routerPage(item)">
          <div class="section-header">
            <h3>{{ item.title }}</h3>
          </div>
        </div>

        <!-- 联系信息 -->
        <div class="contact-section">
          <div class="logo-section">
            <div class="logo">
              <img class="footer-logo-img" src="@/assets/logo.png" alt="Yacoo Logo">
            </div>
            <div class="social-links">
              <div
                  class="social-item"
                  v-for="item in socialList"
                  :key="item.type"
                  @click="showQRCode(item.type, $event)"
              >
                <img
                    :src="item.icon"
                    :alt="item.title"
                    :title="item.title"
                    class="social-icon"
                />
                <!-- 二维码弹窗 - 使用teleport传送到body -->
                <teleport to="body">
                  <div
                      class="qr-modal qr-float"
                      v-if="currentHoverType === item.type"
                      :class="['qr-float-' + item.type]"
                      :data-type="item.type"
                      :style="getQRPosition($event)"
                  >
                    <div class="qr-content">
                      <img :src="item.qr" :alt="item.title + '二维码'" class="qr-code" />
                    </div>
                    <div class="qr-info">
                      <div class="qr-title">{{ item.title }}</div>
                      <div class="qr-tip">{{ $t('footer.qrCode.scanToFollow') }}</div>
                    </div>
                  </div>
                </teleport>
              </div>
            </div>
          </div>
          <div class="contact-info">
            <div class="contact-item" v-if="currentLanguage ==='zh'">
              <span>QQ</span> 2269920866
            </div>
            <div class="contact-item"> <span>{{ $t('footer.contact.phone') }}</span> {{currentLanguage !=='zh'?'86-15062454963': '13451648594'}}</div>
            <div class="contact-item"> <span>{{ $t('footer.contact.email') }}</span> mkt@yacoo.com.cn </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 备案信息 -->
    <div class="footer-bh">
      {{ $t('footer.copyright') }}[
      <a 
        href="https://beian.miit.gov.cn/" 
        target="_blank" 
        rel="noopener noreferrer"
        class="icp-link"
      >
        {{ $t('footer.icp') }}
      </a>]
    </div>
  </footer>
</template>

<script>
import gsap from 'gsap'
import {getRoutes} from "@/api/menu";
import { getFootLink } from '@/api'
import {mapState} from "vuex";
import { pushWithLanguage } from '@/utils/routeUtils'

export default {
  name: 'TheFooter',
  data() {
    return {
      friendLinks: [],
      productsMenuItems: [],
      solutionItems: [],
      menuItems: [],
      lastListRouter: [],
      currentHoverType: null,
      expandedSections: {}, // 改为空对象，动态管理每个菜单的展开状态
      qrPosition: { top: 0, left: 0 } // 添加二维码位置状态
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state.app.language
    })
  },
  // 添加路由监听器
  watch: {
    async currentLanguage() {
      this.initMenuCache()
      await this.getFriendLinks()
      // 语言切换后重新计算二维码位置
      this.$nextTick(() => {
        this.updateQRPosition()
      })
    }
  },

  created() {
    this.initMenuCache()
    this.getFriendLinks()
  },
  mounted() {
    setTimeout(() => {
      const solutionItems = localStorage.getItem('solutionItems');
      this.solutionItems = JSON.parse(solutionItems)
    }, 2000)
    this.initGSAPAnimations()

    // 监听窗口大小变化，重新计算二维码位置
    window.addEventListener('resize', this.updateQRPosition)
    // 监听滚动，重新计算二维码位置
    window.addEventListener('scroll', this.updateQRPosition)
  },

  beforeUnmount() {
    // 清理事件监听器
    window.removeEventListener('resize', this.updateQRPosition)
    window.removeEventListener('scroll', this.updateQRPosition)
  },

  methods: {
    // 计算二维码位置
    getQRPosition(event) {
      if (!event || !event.target) return {}

      const iconRect = event.target.getBoundingClientRect()
      const viewportHeight = window.innerHeight
      const viewportWidth = window.innerWidth

      // 二维码尺寸
      const qrWidth = 124 // 12px padding * 2 + 100px qr-code
      const qrHeight = 140 // 估算高度

      let top = iconRect.top - qrHeight - 30 // 默认在图标上方
      let left = iconRect.left + (iconRect.width / 2) - (qrWidth / 2)

      // 如果二维码会超出屏幕顶部，则显示在图标下方
      if (top < 20) {
        top = iconRect.bottom + 8
      }

      // 如果二维码会超出屏幕右侧，调整左边距
      if (left + qrWidth > viewportWidth - 20) {
        left = viewportWidth - qrWidth - 20
      }

      // 如果二维码会超出屏幕左侧，调整左边距
      if (left < 20) {
        left = 20
      }

      return {
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
        zIndex: 9999
      }
    },

    // 更新二维码位置
    updateQRPosition() {
      if (this.currentHoverType) {
        const qrElement = document.querySelector('.qr-float-' + this.currentHoverType)
        if (qrElement) {
          // 查找对应的图标元素
          const iconElement = document.querySelector(`.social-item .social-icon[alt*="${this.getSocialTitle(this.currentHoverType)}"]`)
          if (iconElement) {
            const newPosition = this.getQRPosition({ target: iconElement })
            Object.assign(qrElement.style, newPosition)
          }
        }
      }
    },

    // 根据类型获取社交媒体标题
    getSocialTitle(type) {
      const socialItem = this.socialList?.find(item => item.type === type)
      return socialItem?.title || ''
    },

    // 初始化GSAP动画
    initGSAPAnimations() {
      // 初始化时隐藏所有二维码
      this.hideAllQRCodes()
    },

    // 显示二维码
    showQRCode(type, event) {
      if (this.currentHoverType === type) {
        this.initGSAPAnimations()
        return
      }
      // 先隐藏所有其他二维码
      this.hideAllQRCodes()

      this.currentHoverType = type

      // 使用nextTick确保DOM更新后再获取元素
      this.$nextTick(() => {
        const qrElement = document.querySelector('.qr-float-' + type)
        if (qrElement) {
          // 计算并设置位置
          const position = this.getQRPosition(event)
          Object.assign(qrElement.style, position)

          // 图标动画
          gsap.to(event.target, {
            scale: 1.1,
            duration: 0.3,
            ease: "back.out(1.7)"
          })

          // 二维码显示动画
          gsap.to(qrElement, {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 0.4,
            ease: "back.out(1.7)",
            onStart: () => {
              qrElement.style.pointerEvents = 'auto'
            }
          })

          // 二维码内容动画
          const qrContent = qrElement.querySelector('.qr-content')
          const qrInfo = qrElement.querySelector('.qr-info')

          if (qrContent) {
            gsap.fromTo(qrContent,
                { y: -10, opacity: 0 },
                { y: 0, opacity: 1, duration: 0.3, delay: 0.1, ease: "power2.out" }
            )
          }

          if (qrInfo) {
            gsap.fromTo(qrInfo,
                { y: 10, opacity: 0 },
                { y: 0, opacity: 1, duration: 0.3, delay: 0.2, ease: "power2.out" }
            )
          }
        }
      })
    },

    // 隐藏所有二维码
    hideAllQRCodes() {
      const allQRElements = document.querySelectorAll('.qr-float')
      allQRElements.forEach(element => {
        gsap.set(element, {
          opacity: 0,
          scale: 0.8,
          y: 20,
          pointerEvents: 'none'
        })
      })
      this.currentHoverType = null
    },

    //菜单跳转
    handleMenuClick (item,child) {
      // 判断当前路由是否和目标一致
      const currentPath = this.$route.path
      const currentQuery = this.$route.query.product
      const isSamePath = currentPath === '/'+item.url+'/'+child.url
      const isSameQuery = JSON.stringify(currentQuery) === JSON.stringify(item)

      if (isSamePath && isSameQuery) {
        // 已经在当前页面且参数一致，不做跳转
        return
      }
      pushWithLanguage(`/${item.url}/${child.url}`, this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err)
        }
      })
    },

    routerPage (item) {
      if (!item.url) {
        return
      }

      const currentPath = this.$route.path
      const targetPath = this.generateLanguagePath(`/${item.url}`)

      if (currentPath === targetPath) {
        // 已经在当前页面，不做跳转
        return
      }

      // 使用 pushWithLanguage 进行跳转
      pushWithLanguage(`/${item.url}`, this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由跳转失败:', err)
        }
      })
    },

    // 修改 toggleSection 方法
    toggleSection(menuIndex) {
      const menuItem = this.menuItems[menuIndex]
      if (!menuItem || !menuItem.children || menuItem.children.length === 0) {
        return
      }

      const targetList = document.querySelector(`.products-section:nth-child(${menuIndex + 1}) .products-list`)

      if (this.expandedSections[menuIndex]) {
        // 收起动画
        gsap.to(targetList, {
          height: 0,
          opacity: 0,
          duration: 0.3,
          ease: "power2.inOut",
          onComplete: () => {
            this.$set(this.expandedSections, menuIndex, false)
          }
        })
      } else {
        // 先收起所有其他菜单
        for (let key in this.expandedSections) {
          if (this.expandedSections[key]) {
            const otherList = document.querySelector(`.products-section:nth-child(${parseInt(key) + 1}) .products-list`)
            if (otherList) {
              gsap.to(otherList, {
                height: 0,
                opacity: 0,
                duration: 0.3,
                ease: "power2.inOut"
              })
            }
            this.$set(this.expandedSections, key, false)
          }
        }

        // 展开当前菜单
        this.$set(this.expandedSections, menuIndex, true)
        this.$nextTick(() => {
          gsap.fromTo(targetList,
              {
                height: 0,
                opacity: 0
              },
              {
                height: "auto",
                opacity: 1,
                duration: 0.4,
                ease: "power2.out"
              }
          )
        })
      }
    },

    async initMenuCache() {
      try {
        const routers = await getRoutes({bottom:1});
        if (routers.success) {
          // 动态构建菜单项
          const menuData = routers.data;
          this.menuItems = menuData.filter(item => {if (item.children.length > 0) {
            const menuItem = {
              ...item,
              ...{path: '/' + (item.url || item.path || '')}
            };
            // 如果有子菜单，构建二级菜单
            if (item.children && item.children.length > 0) {
              menuItem.children = item.children.map(child => ({
                ...child ,
                ...{path: '/' + (item.url || '') + '/' + (child.url || '')} // 拼接父级url和子级url
              }));
            }
            return menuItem;
          }});
          this.lastListRouter=  menuData.filter(e => { if (e.children.length === 0) return {e} });
          console.log(  this.lastListRouter , this.menuItems, '----')
          // 将路由数据存储到本地缓存
          localStorage.setItem('menuItems', JSON.stringify(this.menuItems));
        }
      } catch (e) {
        console.error('获取菜单数据失败', e);
        // 兜底：如果接口失败，尝试读取本地缓存
        let menuItems = localStorage.getItem('menuItems');
        if (menuItems) {
          try {
            this.menuItems = JSON.parse(menuItems);
          } catch (parseError) {
            console.error('解析菜单缓存失败', parseError);
          }
        }
      }
    },
    //获取二维码列表. socialList
    async getFriendLinks() {
      try {
        const res = await getFootLink()
        if (res.code === 200 && Array.isArray(res.data)) {
          const mapped = this.mapFootLinkData(res.data)
          this.socialList = mapped
          //存入缓存
          localStorage.setItem('socialList', JSON.stringify(mapped))
        } else {
          this.socialList = this.defaultSocialList()
        }
      } catch (error) {
        console.error('获取友情链接数据失败:', error)
        this.socialList = this.defaultSocialList()
      }
    },
    // 将接口数据映射为组件所需结构
    mapFootLinkData(list) {
      return list.map((item, idx) => {
        const t = `type_${idx}`
        return {
          type: t,
          icon: item.icon,     // 接口字段：图标
          qr: item.qrcode,     // 接口字段：二维码
          title: item.title
        }
      })
    },

    // 接口失败时的兜底数据（与原先一致）
    defaultSocialList() {
      return [
        {
          type: 'wechat',
          icon: require('@/assets/images/wx.png'),
          qr: 'https://file.yacoo.com.cn/staticResource/common/yacoo-wechat.webp',
          title: this.$t('footer.socialMedia.wechat')
        },
        {
          type: 'tiktok',
          icon: require('@/assets/images/dy.png'),
          qr: 'https://file.yacoo.com.cn/staticResource/common/yacoo-tiktok.webp',
          title: this.$t('footer.socialMedia.tiktok')
        },
        {
          type: 'xiaohongshu',
          icon: require('@/assets/images/xhs.png'),
          qr: 'https://file.yacoo.com.cn/staticResource/common/yacoo-xhs.webp',
          title: this.$t('footer.socialMedia.xiaohongshu')
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  width: 100vw;
  background: #123769;
  color: #fff;
  padding: 30px 0 0 0;
  border-top: 4px solid #E26E76;;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  .footer-section {
    width: 100%;
    box-sizing: border-box;
    padding: 0 24px;
    margin-bottom: 24px;
  }
  .products-section {
    padding:  10px 0;
    background: #123769;
    .section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3 {
        font-size: 14px;
        font-weight: bold;
        margin: 0;
      }
      .dropdown-icon {
        font-size: 12px;
        color: #b2c6e5;
      }
    }
    .products-list {
      margin: 0;
      padding: 0;
      list-style: none;
      overflow: hidden; // 添加这行
      li {
        font-size: 12px;
        color: #b2c6e5;
        margin: 16px 0;
        padding-left: 8px;
        cursor: pointer;
        &:hover {
          color: #fff;
        }
      }
    }
  }
  .nav-section {
    background: #123769;
    .nav-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 0;
      border-bottom: 1px solid rgba(255,255,255,0.08);
      .nav-text {
        font-size: 14px;
        color: #fff;
      }
      .arrow-icon {
        font-size: 20px;
        color: #b2c6e5;
      }
    }
    .nav-item:last-child {
      border-bottom: none;
    }
  }
  .contact-section {
    background: #123769;
    padding-bottom: 24px;
    padding-top: 35px;
    .logo-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 18px;
      .logo {
        display: flex;
        align-items: center;
        .footer-logo-img {
          width: 75px;
          height: auto;
        }
      }
      .social-links {
        display: flex;
        align-items: center;
        gap: 8.5px;
        .social-item {
          position: relative;
          .social-icon {
            width: 15px;
            height: 15px;
            cursor: pointer;
            transition: transform 0.2s ease;
            &:hover {
              transform: scale(1.1);
            }
          }
        }
      }
    }
    .contact-info {
      .contact-item {
        font-size: 12px;
        color: #FFFFFF;
        line-height: 18px;
        margin-bottom: 4px;
      }
    }
  }
  .footer-bh {
    width: 100vw;
    background: rgba(255,255,255,0.05);
    text-align: center;
    font-size: 10px;
    color: #b2c6e5;
    padding: 13px 0 8px 0;
    font-weight: 400;
    .icp-link {
      color: #b2c6e5;
      text-decoration: none;
      font-size: 10px;
      font-weight: 400;
      &:hover {
        color: #fff;
        text-decoration: none;
      }
    }
  }
}

/* 二维码弹窗样式 - 全局样式，不使用scoped */
.qr-modal {
  position: fixed;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  padding: 12px;
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  transform: scale(0.8) translateY(20px);

  .qr-content {
    display: flex;
    flex-direction: column;
    .qr-code {
      width: 100px;
      height: 100px;
      border-radius: 8px;
      margin-bottom: 8px;
    }
  }

  .qr-info {
    text-align: center;
    .qr-title {
      font-size: 12px;
      font-weight: 600;
      color: #333;
      margin-bottom: 2px;
    }
    .qr-tip {
      font-size: 10px;
      color: #666;
    }
  }

  .qr-arrow {
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #fff;
  }
}

@media (min-width: 600px) {
  .footer {
    min-width: 0;
    max-width: 480px;
    margin: 0 auto;
  }
}
</style> 